import { ChangeLogResources } from '@lp/features/RoutePlanner/components/LogisticsChangeLog/components/ChangeLogResource';
import { DeviceTrackingDeviceType } from '@/api/apis/route';
import { CaseResourceType } from '@/api/apis/case';

type TrackingDeviceInfoProps = {
  device: DeviceTrackingDeviceType;
};

export const TrackingDeviceInfo = ({ device }: TrackingDeviceInfoProps) => {
  return (
    <div className="flex gap-1.5 items-center">
      <span className="text-s-m text-base-5">Device:</span>
      <ChangeLogResources type={CaseResourceType.OCSConsole} title={device.fullSerialNumber} />
    </div>
  );
};
